import { render, staticRenderFns } from "./ChooseSuplierField.vue?vue&type=template&id=6e47b38e"
import script from "./ChooseSuplierField.vue?vue&type=script&lang=js"
export * from "./ChooseSuplierField.vue?vue&type=script&lang=js"
import style0 from "./ChooseSuplierField.vue?vue&type=style&index=0&id=6e47b38e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports